import React from "react";
import { DownloadSimple } from "@phosphor-icons/react";
import { API, ADMIN_TOKEN_KEY } from "@/lib/api";

export function TicketAttachments({ t }) {
  const files = t.attachments || [];
  if (!files.length) return null;
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  const url = (i) => `${API}/admin/support-tickets/${t.id}/file/${i}?auth=${token}`;
  return (
    <div className="px-3.5" data-testid="support-ticket-attachments">
      <div className="text-[0.62rem] uppercase tracking-[0.18em] font-bold text-neutral-500 mb-1.5">Attachments · {files.length}</div>
      <div className="flex flex-wrap gap-2">
        {files.map((f, i) => (f.kind === "video" ? (
          <div key={i} className="w-44 rounded-lg overflow-hidden border border-neutral-800 bg-black" data-testid="support-ticket-attachment-video">
            <video src={url(i)} controls preload="metadata" className="w-full h-28 object-cover bg-black" />
            <a href={url(i)} download={f.filename} className="flex items-center gap-1.5 px-2 py-1.5 text-[0.65rem] text-neutral-400 hover:text-[#73bf44] transition-colors">
              <DownloadSimple size={12} className="shrink-0" /> <span className="truncate">{f.filename}</span>
            </a>
          </div>
        ) : (
          <a key={i} href={url(i)} target="_blank" rel="noreferrer" title={f.filename} data-testid="support-ticket-attachment-photo"
            className="w-28 h-28 rounded-lg overflow-hidden border border-neutral-800 hover:border-[#73bf44] transition-colors bg-black/40">
            <img src={url(i)} alt={f.filename} loading="lazy" className="w-full h-full object-cover" />
          </a>
        )))}
      </div>
    </div>
  );
}
